module.exports = __webpack_public_path__ + "60df07241ddea9e2e7ec2ad28123a9dd.pdf";